import type { PaletteVariant } from '@blade/ui-kit'
import type { PurchaseBoostersType } from '@root/features/premium'

export const ACTION_BUTTON_COLOR_MAP: Record<
  PurchaseBoostersType,
  PaletteVariant
> = {
  boosters: 'acid',
  premium: 'premium',
}
